import apiTrainingTemplate from '@/api/trainings-template'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  Training: null
}

export const mutationTypes = {
  updateTrainingTemplateStart:
    '[update training template] Update training template start',
  updateTrainingTemplateSuccess:
    '[update training template] Update training template success',
  updateTrainingTemplateFailure:
    '[update training template] Update training template failure',

  getTrainingTemplateStart:
    '[update training template] Get training template start',
  getTrainingTemplateSuccess:
    '[update training template] Get training template success',
  getTrainingTemplateFailure:
    '[update training template] Get training template failure'
}

export const actionTypes = {
  updateTrainingTemplate: '[update training template] Update training template',
  getTrainingTemplate: '[update training template] Get training template'
}

const mutations = {
  [mutationTypes.updateTrainingTemplateStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateTrainingTemplateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateTrainingTemplateFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getTrainingTemplateStart](state) {
    state.isLoading = true
    state.Training = null
  },

  [mutationTypes.getTrainingTemplateSuccess](state, payload) {
    state.Training = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingTemplateFailure](state, payload) {
    state.error = payload
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateTrainingTemplate](context, {id, template}) {
    context.commit(mutationTypes.updateTrainingTemplateStart)
    return new Promise(resolve => {
      apiTrainingTemplate
        .updateTrainingTemplate(id, template)
        .then(response => {
          context.commit(mutationTypes.updateTrainingTemplateSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateTrainingTemplateFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getTrainingTemplate](context, {id}) {
    context.commit(mutationTypes.getTrainingTemplateStart)
    return new Promise(resolve => {
      apiTrainingTemplate
        .getTrainingTemplate(id)
        .then(response => {
          context.commit(
            mutationTypes.getTrainingTemplateSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingTemplateFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
